export default __webpack_public_path__ + "static/media/login-title-cn.f82e7f4c.webp";